/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { GridColumnOptionsViewBase } from "./GridColumnOptionsViewBase";
import { SummaryChooser } from "./SummaryChooser";
import { Popup } from "igniteui-react-layouts";
import { Size } from "igniteui-react-core";
import { GridColumnOptionsUtilities } from "./GridColumnOptionsUtilities";
import { runOn, markType, enumGetBox, delegateRemove, delegateCombine } from "igniteui-react-core";
import { ControlDisplayDensity_$type } from "igniteui-react-core";
import { Rect } from "igniteui-react-core";
import { GridColumnOptionsSectionBase } from "./GridColumnOptionsSectionBase";
import { ColumnSummaryDescription } from "./ColumnSummaryDescription";
import { stringFormat } from "igniteui-react-core";
import { stringIsNullOrWhiteSpace } from "igniteui-react-core";
/**
 * @hidden
 */
var GridColumnSummaryOptionsView = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(GridColumnSummaryOptionsView, _super);
    function GridColumnSummaryOptionsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.o = null;
        _this.p = null;
        return _this;
    }
    Object.defineProperty(GridColumnSummaryOptionsView.prototype, "n", {
        get: function () {
            return this.b;
        },
        enumerable: false,
        configurable: true
    });
    GridColumnSummaryOptionsView.prototype.k = function () {
        var _this = this;
        _super.prototype.k.call(this);
        if (null == this.g || null == this.e) {
            return;
        }
        if (this.n.b4 == null) {
            var a_1;
            var b_1;
            var c_1;
            this.o = ((function () { var d = GridColumnOptionsUtilities.g(_this.n, _this.e, GridColumnSummaryOptionsView.r, 1, _this.n.p, _this.n.j, new Size(1, 24, 24), a_1, b_1, _this.p, c_1, false, true); a_1 = d.p7; b_1 = d.p8; _this.p = d.p9; c_1 = d.p10; return d.ret; })());
            c_1.setStyleProperty("transform", "rotate(-90deg)");
            this.g.append(this.o);
            this.n.ci(a_1);
        }
        if (this.n.bx == null) {
            var d = new SummaryChooser();
            d.a2(this.e);
            this.n.cm(d);
            var e = this.e.createElement("div");
            var f = this.e.getSubRenderer(e);
            var g = new Popup();
            g.provideRenderer(f);
            g.appendPopupContent(d.c.container);
            this.n.cj(g);
        }
        document.addEventListener("mousedown", runOn(this, this.s), false);
    };
    GridColumnSummaryOptionsView.prototype.m = function () {
        _super.prototype.m.call(this);
        this.n.bh(this.n.b4);
        if (this.o != null) {
            this.o.setStyleProperty("margin", "0 -8px");
            switch (this.n.b4.g) {
                case 2:
                    this.p.setStyleProperty("margin", "0 -.25rem");
                    break;
                case 1:
                case 3:
                    this.p.setStyleProperty("margin", "0 -.5rem");
                    break;
            }
            this.p.setRawText(this.n.cb);
            this.p.setStyleProperty("font", this.n.aa.fontString);
        }
    };
    GridColumnSummaryOptionsView.prototype.t = function () {
        if (this.o != null) {
            var a = this.o.getNativeElement().getBoundingClientRect();
            var b = new Rect(4);
            b.left = (a.left);
            b.top = (a.top);
            b.width = (a.width);
            b.height = (a.height);
            return b;
        }
        return Rect.empty;
    };
    GridColumnSummaryOptionsView.prototype.u = function () {
        var a = this.t();
        a.x += window.pageXOffset;
        a.y += window.pageYOffset;
        return a;
    };
    GridColumnSummaryOptionsView.prototype.q = function () {
        return (window.innerWidth);
    };
    GridColumnSummaryOptionsView.prototype.s = function (e_) {
        this.n.ch();
    };
    GridColumnSummaryOptionsView.$t = markType(GridColumnSummaryOptionsView, 'GridColumnSummaryOptionsView', GridColumnOptionsViewBase.$);
    GridColumnSummaryOptionsView.r = "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z";
    return GridColumnSummaryOptionsView;
}(GridColumnOptionsViewBase));
export { GridColumnSummaryOptionsView };
/**
 * @hidden
 */
var GridColumnSummaryOptions = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(GridColumnSummaryOptions, _super);
    function GridColumnSummaryOptions() {
        var _this = _super.call(this) || this;
        _this.b3 = null;
        _this.b5 = null;
        _this.bw = null;
        _this.b8 = null;
        _this.bz = 0;
        _this.by = 0;
        _this.b6 = 0;
        return _this;
    }
    GridColumnSummaryOptions.prototype.f = function () {
        return new GridColumnSummaryOptionsView();
    };
    GridColumnSummaryOptions.prototype.bs = function () {
        if (this.column == null) {
            return false;
        }
        if (!this.column.gt) {
            return false;
        }
        return this.c.it && this.c.f3 != 3;
    };
    GridColumnSummaryOptions.prototype.be = function (a, b, c) {
        _super.prototype.be.call(this, a, b, c);
        switch (a) {
            case "ActualBaseTheme":
            case "ActualDensity":
            case "ActualSummaryListDensity":
            case "BackgroundColor":
            case "TextColor":
                this.co();
                this.cn();
                this.cp();
                break;
            case "SummaryListDensity":
                this.b0 = this.b2 == 0 ? this.q : this.b2;
                break;
            case "SummaryCaption":
            case "ActualLabelTextStyle":
            case "ActiveCount":
                this.bv.m();
                break;
        }
    };
    GridColumnSummaryOptions.prototype.bt = function () {
        if (this.bw != null) {
            var a = this.bw.a();
            for (var b = 0; b < a.length; b++) {
                var c = new ColumnSummaryDescription(1, this.column.io);
                switch (a[b]) {
                    case "avg":
                        c.n = 3;
                        break;
                    case "count":
                        c.n = 4;
                        break;
                    case "max":
                        c.n = 1;
                        break;
                    case "min":
                        c.n = 0;
                        break;
                    case "sum":
                        c.n = 2;
                        break;
                }
                for (var d = 0; d < this.c.b9.i.count; d++) {
                    var e = this.c.b9.i.item(d);
                    if (e.af == this.column.io && e.n == c.n) {
                        this.c.b9.i.removeAt(d);
                        d--;
                    }
                }
            }
            var f = this.bw.b();
            for (var g = 0; g < f.length; g++) {
                var h = new ColumnSummaryDescription(1, this.column.io);
                switch (f[g]) {
                    case "avg":
                        h.n = 3;
                        break;
                    case "count":
                        h.n = 4;
                        break;
                    case "max":
                        h.n = 1;
                        break;
                    case "min":
                        h.n = 0;
                        break;
                    case "sum":
                        h.n = 2;
                        break;
                }
                var i = false;
                for (var j = 0; j < this.c.b9.i.count; j++) {
                    var k = this.c.b9.i.item(j);
                    if (k.af == this.column.io && k.n == h.n) {
                        i = true;
                        break;
                    }
                }
                if (!i) {
                    this.c.b9.i.add(h);
                    this.column.js("Summed");
                }
            }
        }
        if (this.b5 != null && this.b5.t) {
            this.b5.ao();
        }
    };
    GridColumnSummaryOptions.prototype.bu = function () {
        if (this.b5 != null && this.b5.t) {
            this.b5.ao();
        }
    };
    GridColumnSummaryOptions.prototype.a6 = function () {
        _super.prototype.a6.call(this);
        if (this.column != null) {
            this.b7 = 0;
            for (var a = 0; a < this.c.b9.i.count; a++) {
                var b = this.c.b9.i.item(a);
                if (b.af == this.column.io) {
                    switch (b.n) {
                        case 3:
                            this.bw.a4("avg", true);
                            this.b7++;
                            break;
                        case 4:
                            this.bw.a4("count", true);
                            this.b7++;
                            break;
                        case 1:
                            this.bw.a4("max", true);
                            this.b7++;
                            break;
                        case 0:
                            this.bw.a4("min", true);
                            this.b7++;
                            break;
                        case 2:
                            this.bw.a4("sum", true);
                            this.b7++;
                            break;
                    }
                }
            }
        }
    };
    Object.defineProperty(GridColumnSummaryOptions.prototype, "cb", {
        get: function () {
            if (this.b7 > 0) {
                return stringFormat("{0} ({1})", this.cd, this.b7);
            }
            else {
                return this.cd;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GridColumnSummaryOptions.prototype, "b4", {
        get: function () {
            return this.b3;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GridColumnSummaryOptions.prototype, "bx", {
        get: function () {
            return this.bw;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GridColumnSummaryOptions.prototype, "bv", {
        get: function () {
            return this.e;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GridColumnSummaryOptions.prototype, "cd", {
        get: function () {
            if (this.b8 == null) {
                var a = this.ai.b1("Column_Options_Summary_Average");
                return !stringIsNullOrWhiteSpace(a) ? a : "Summaries";
            }
            else {
                return this.b8;
            }
        },
        set: function (a) {
            var b = this.b8;
            this.b8 = a;
            if (b != this.b8) {
                this.bc("SummaryCaption", b, this.b8);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GridColumnSummaryOptions.prototype, "b2", {
        get: function () {
            return this.bz;
        },
        set: function (a) {
            var b = this.bz;
            this.bz = a;
            if (b != this.bz) {
                this.bc("SummaryListDensity", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, this.bz));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GridColumnSummaryOptions.prototype, "b0", {
        get: function () {
            return this.by;
        },
        set: function (a) {
            var b = this.by;
            this.by = a;
            if (b != this.by) {
                this.bc("ActualSummaryListDensity", enumGetBox(ControlDisplayDensity_$type, b), enumGetBox(ControlDisplayDensity_$type, this.by));
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GridColumnSummaryOptions.prototype, "b7", {
        get: function () {
            return this.b6;
        },
        set: function (a) {
            var b = this.b6;
            this.b6 = a;
            if (b != this.b6) {
                this.bc("ActiveCount", b, this.b6);
            }
        },
        enumerable: false,
        configurable: true
    });
    GridColumnSummaryOptions.prototype.ch = function () {
        if (this.b5 != null && this.b5.t) {
            this.b5.ao();
        }
    };
    GridColumnSummaryOptions.prototype.ci = function (a) {
        if (this.b3 != null) {
            var b = this.b3;
            b.clicked = delegateRemove(b.clicked, runOn(this, this.ck));
        }
        this.b3 = a;
        if (this.b3 != null) {
            var c = this.b3;
            c.clicked = delegateCombine(c.clicked, runOn(this, this.ck));
        }
        this.cn();
    };
    GridColumnSummaryOptions.prototype.cj = function (a) {
        this.b5 = a;
        this.cp();
    };
    GridColumnSummaryOptions.prototype.cm = function (a) {
        if (this.bw != null) {
            var b = this.bw;
            b.summaryChanged = delegateRemove(b.summaryChanged, runOn(this, this.cl));
        }
        this.bw = a;
        if (this.bw != null) {
            var c = this.bw;
            c.summaryChanged = delegateCombine(c.summaryChanged, runOn(this, this.cl));
        }
        this.co();
    };
    GridColumnSummaryOptions.prototype.co = function () {
        if (this.bw != null) {
            this.bw.h = this.i;
            this.bw.l = this.b0;
            this.bw.ba = this.br;
        }
    };
    GridColumnSummaryOptions.prototype.cn = function () {
        if (this.b3 != null) {
            this.b3.ef = 0;
            this.b3.ak = false;
            this.b3.t8 = this.br;
            this.bh(this.b3);
        }
    };
    GridColumnSummaryOptions.prototype.cp = function () {
        if (this.b5 != null) {
            this.b5.a8 = this.bo;
            this.b5.q = false;
        }
    };
    GridColumnSummaryOptions.prototype.ck = function (a, b) {
        if (this.b5 == null) {
            return;
        }
        if (this.b5.t) {
            this.b5.ao();
        }
        else {
            var c = this.bv.t();
            var d = this.bv.u();
            var e = this.bv.q();
            var f = 150;
            if (c.right > e - f - 10) {
                d.x -= f;
                d.y -= d.height;
            }
            else {
                d.x += d.width;
                d.y -= d.height;
            }
            this.b5.showRelativeToExclusionRect(d, 1, 0);
        }
    };
    GridColumnSummaryOptions.prototype.cl = function (a, b) {
        if (b.a) {
            this.b7++;
        }
        else {
            this.b7--;
        }
    };
    GridColumnSummaryOptions.$t = markType(GridColumnSummaryOptions, 'GridColumnSummaryOptions', GridColumnOptionsSectionBase.$);
    return GridColumnSummaryOptions;
}(GridColumnOptionsSectionBase));
export { GridColumnSummaryOptions };
//# sourceMappingURL=GridColumnSummaryOptionsView_combined.js.map
